module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABJElEQVQ4T63SMUvDQBQH8P87wsEp6iJuTupXcMhNwe9QsKuDXSUQsRwRNIGQSXFQP0A/gZ+hWYyTqzi6OZRCA2lyT1oIaKkSpDcd3P34v3f3yBhziX8sMsYwgBGAoqVXALYa2Iui6LENNMacAnhYDcyy7JCZdxeS87IsR1LKA63189LE4XD4BmBvAd4T0QszX2it95fCPM/XxuPxZgOVUlwUxafneVWWZcp13WI1PVprQ2vtIEmS9yYtCIINKeVOVVX0vXQhxLEQ4qp51dnZJIqidd/3t5VStwA6AJzfvojCMDyq67pDRF1r7YkQ4g6AZOZrZn51HMcuw/MyjDHnAJLZnpmfptNpL03Tj78GYg77/X6XiG4AnMVxPGgzQT8abwOaO19FfJPKxtDRxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/myGive_icon/66.png
// module id = fTi5
// module chunks = 0